import { useMutation, useQueryClient } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { FileListItemType } from '@views/documents/elements/FileList'

import { QueryKeys } from '../../../enums/queryKeys'
import { renameDocument, renameFolder } from '../query-api'
import { DmsDocument, DmsFolderNode } from '../types'

interface RenameItemParams {
  id: string
  type: FileListItemType
  name: string
}

export const useRenameItem = () => {
  const queryClient = useQueryClient()
  const { organization } = useUserOrganization()

  const { mutate, isLoading } = useMutation<DmsDocument | DmsFolderNode, unknown, RenameItemParams>(
    ({ id, type, name }: RenameItemParams) => {
      const organizationId = organization?.id as string
      return type === 'document'
        ? renameDocument({ organizationId, documentId: id, name })
        : renameFolder({ organizationId, folderId: id, name })
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(QueryKeys.DmsFolderContents)
        if (variables.type === 'folder') {
          queryClient.invalidateQueries(QueryKeys.DmsFolders)
        }
      },
    },
  )

  return {
    renameItem: mutate,
    isLoading,
  }
}
